import { User } from 'functions/src/types/firestore/User';
import { User as FirebaseUser } from 'firebase/auth';
export const isUserVerified = (
  user: FirebaseUser | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userData: User<any> | null,
) => {
  if (!user || !userData) {
    return true;
  }
  return (
    user.emailVerified ||
    user.providerData.length === 0 ||
    user.providerData.some((provider) => provider.providerId !== 'password')
  );
};
